<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="font-weight-bold">
                                Objetivos e Metas - Criança e Adolescente
                            </h4>
                        </div>
                    </div>
                    <div class="row px-3">
                        <ul class="nav nav-pills flex-column col-md-3 px-0">
                            <li class="nav-item mb-2">
                                <a
                                    @click="aba = 'documental'"
                                    :class="aba == 'documental' ? 'active' : ''"
                                    class="list-group-item nav-link list-group-item-action"
                                    >Situação Documental</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'processual'"
                                    :class="aba == 'processual' ? 'active' : ''"
                                    >Situação Processual</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'saude'"
                                    :class="aba == 'saude' ? 'active' : ''"
                                    >Saúde</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'educacao'"
                                    :class="aba == 'educacao' ? 'active' : ''"
                                    >Educação</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'profissionalizacao'"
                                    :class="
                                        aba == 'profissionalizacao'
                                            ? 'active'
                                            : ''
                                    "
                                    >Profissionalização</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'arte'"
                                    :class="aba == 'arte' ? 'active' : ''"
                                    >Arte, Cultura, Esporte E Lazer</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'aspecto'"
                                    :class="aba == 'aspecto' ? 'active' : ''"
                                    >Aspectos Sociofamiliares</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'condicao'"
                                    :class="aba == 'condicao' ? 'active' : ''"
                                    >Condições Socioeconômicas
                                </a>
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'vulnerabilidade'"
                                    :class="
                                        aba == 'vulnerabilidade' ? 'active' : ''
                                    "
                                    >Vulnerabilidade e Riscos</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'autonomia'"
                                    :class="aba == 'autonomia' ? 'active' : ''"
                                    >Autonomia / autoestima / identidade
                                </a>
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'preparacao'"
                                    :class="aba == 'preparacao' ? 'active' : ''"
                                    >Preparação para desligamento</a
                                >
                            </li>
                        </ul>
                        <div class="col-md-9">
                            <div v-show="aba == 'documental'">
                                <div class="row">
                                    <h4 class="px-3">Situação Documental</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.documental_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.documental_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.documental_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'processual'">
                                <div class="row">
                                    <h4 class="px-3">Situação Processual</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.processual_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.processual_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.processual_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'saude'">
                                <div class="row">
                                    <h4 class="px-3">Saúde</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.saude_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.saude_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.saude_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'educacao'">
                                <div class="row">
                                    <h4 class="px-3">Educação</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.educacao_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.educacao_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.educacao_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'profissionalizacao'">
                                <div class="row">
                                    <h4 class="px-3">Profissionalização</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="
                                            metaCrianca.profissionalizacao_prazo
                                        "
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.profissionalizacao_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.profissionalizacao_meta
                                        "
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'arte'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Arte, Cultura, Esporte E Lazer
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.arte_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.arte_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.arte_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'aspecto'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Aspectos Sociofamiliares
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.aspecto_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.aspecto_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.aspecto_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'condicao'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Condições Socioeconômicas
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.condicao_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.condicao_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.condicao_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'vulnerabilidade'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Vulnerabilidade sociofamiliares
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="
                                            metaCrianca.vulnerabildiade_prazo
                                        "
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.vulnerabildiade_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.vulnerabildiade_meta
                                        "
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'autonomia'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Autonomia / autoestima / identidade
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.autonomia_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.autonomia_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.autonomia_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'preparacao'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Preparação para desligamento
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metaCrianca.desligamento_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metaCrianca.desligamento_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metaCrianca.desligamento_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div class="row px-2 d-flex justify-content-end">
                                <button
                                    class="btn btn-success btn-submit"
                                    data-style="zoom-in"
                                    @click="submit"
                                    type="submit"
                                >
                                    <i class="mdi mdi-content-save" />
                                    {{ $t("Salvar") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            metaCrianca: {
                documental_prazo: "",
                documental_situacao_atual: "",
                documental_meta: "",
                processual_prazo: "",
                processual_situacao_atual: "",
                processual_meta: "",
                saude_prazo: "",
                saude_situacao_atual: "",
                saude_meta: "",
                educacao_prazo: "",
                educacao_situacao_atual: "",
                educacao_meta: "",
                profissionalizacao_prazo: "",
                profissionalizacao_situacao_atual: "",
                profissionalizacao_meta: "",
                arte_prazo: "",
                arte_situacao_atual: "",
                arte_meta: "",
                aspecto_prazo: "",
                aspecto_situacao_atual: "",
                aspecto_meta: "",
                condicao_prazo: "",
                condicao_situacao_atual: "",
                condicao_meta: "",
                vulnerabildiade_prazo: "",
                vulnerabildiade_situacao_atual: "",
                vulnerabildiade_meta: "",
                desligamento_prazo: "",
                desligamento_situacao_atual: "",
                desligamento_meta: "",
            },
            aba: "documental",
        };
    },
    mounted() {
        if (this.item.metaCrianca) {
            this.metaCrianca = this.item.metaCrianca;
        }
    },
    watch: {
        item(n, o) {
            this.metaCrianca = this.item.metaCrianca;
        },
    },
    methods: {
        submit() {
            // if (this.metaCrianca.processual_prazo != "") {
            // 	this.metaCrianca.processual_prazo = moment(
            // 		this.metaCrianca.processual_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metaCrianca.documental_prazo != "") {
            // 	this.metaCrianca.documental_prazo = moment(
            // 		this.metaCrianca.documental_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metaCrianca.saude_prazo != "") {
            // 	this.metaCrianca.saude_prazo = moment(this.metaCrianca.saude_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metaCrianca.profissionalizacao_prazo != "") {
            // 	this.metaCrianca.profissionalizacao_prazo = moment(
            // 		this.metaCrianca.profissionalizacao_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metaCrianca.educacao_prazo != "") {
            // 	this.metaCrianca.educacao_prazo = moment(
            // 		this.metaCrianca.educacao_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metaCrianca.educacao_prazo != "") {
            // 	this.metaCrianca.educacao_prazo = moment(
            // 		this.metaCrianca.educacao_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metaCrianca.arte_prazo != "") {
            // 	this.metaCrianca.arte_prazo = moment(this.metaCrianca.arte_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metaCrianca.aspecto_prazo != "") {
            // 	this.metaCrianca.aspecto_prazo = moment(this.metaCrianca.aspecto_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metaCrianca.condicao_prazo != "") {
            // 	this.metaCrianca.condicao_prazo = moment(
            // 		this.metaCrianca.condicao_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metaCrianca.vulnerabildiade_prazo != "") {
            // 	this.metaCrianca.vulnerabildiade_prazo = moment(
            // 		this.metaCrianca.vulnerabildiade_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metaCrianca.desligamento_prazo != "") {
            // 	this.metaCrianca.desligamento_prazo = moment(
            // 		this.metaCrianca.desligamento_prazo
            // 	).format("YYYY-MM-DD");
            // }
            this.item.metaCrianca = this.metaCrianca;
            this.$emit("submit");
        },
    },
};
</script>
<style scoped>
li.nav-item mb-2 a {
    cursor: pointer !important;
}
</style>
